// @ts-nocheck
import React from "react";

import { Button, Modal } from "react-bootstrap";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { DateBox } from "devextreme-react/date-box";

import "./SchoolManageDeadlinesModal.scss";

/**
 * @param {Object} props - The props object passed to the component.
 * @param {boolean} props.show - Controls the visibility of the modal.
 * @param {any} props.deadline - Controls the visibility of the modal.
 * @param {Function} props.onInputChange - Controls the visibility of the modal.
 * @param {Function} props.onHide - Callback function triggered when the modal is closed.
 * @param {Function} props.onSave - Callback function triggered when the save button is clicked.
 * @returns {JSX.Element} The rendered modal component.
 */
export function SchoolManageDeadlinesModal(props) {
    const [t] = useTranslation();

    return (
        <Modal {...props} centered dialogClassName="school-manage-deadlines-modal">
            <Modal.Header className="school-manage-deadlines-modal-header" closeButton>
                <div className="title">{t("ModifyDeadline")}</div>
            </Modal.Header>
            <Modal.Body className="school-manage-deadlines-modal-content">
                <Form.Label>Date</Form.Label>
                <Form.Control value={props.deadline.deadline} placeholder="YYYY-MM-DD" onChange={props.onInputChange} />
                <div className="button-wrapper">
                    <Button className="button button-cancel" onClick={() => props.onHide()}>
                        {t("Close")}
                    </Button>
                    <Button
                        className="button"
                        onClick={() => {
                            props.onSave();
                        }}
                    >
                        {t("Save")}
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
}
